import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Avatar,
  IconButton,
} from '@mui/material';
import {
  CreditCard,
  PhoneAndroid,
  AccountBalance,
  CurrencyBitcoin,
  CheckCircle,
} from '@mui/icons-material';
import { PaymentMethod } from '../types/payment.types';

const paymentMethods: PaymentMethod[] = [
  {
    id: 'card',
    name: 'Carte de crédit/débit',
    type: 'card',
    icon: 'card',
    enabled: true,
  },
  {
    id: 'mobile',
    name: 'Paiement Mobile Money',
    type: 'mobile',
    icon: 'mobile',
    enabled: true,
  },
  {
    id: 'bank',
    name: 'Bank Transfer',
    type: 'bank',
    icon: 'bank',
    enabled: false,
  }
];

const getIcon = (iconType: string) => {
  switch (iconType) {
    case 'card':
      return <CreditCard sx={{ fontSize: 40 }} />;
    case 'mobile':
      return <PhoneAndroid sx={{ fontSize: 40 }} />;
    case 'bank':
      return <AccountBalance sx={{ fontSize: 40 }} />;
    case 'crypto':
      return <CurrencyBitcoin sx={{ fontSize: 40 }} />;
    default:
      return <CreditCard sx={{ fontSize: 40 }} />;
  }
};

interface PaymentMethodSelectorProps {
  onSelect: (method: PaymentMethod) => void;
}

const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = ({
  onSelect,
}) => {
  const handleMethodClick = (method: PaymentMethod) => {
    if (method.enabled) {
      onSelect(method);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Sélectionner la méthode de paiement
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Sélectionnez la méthode de paiement préférée pour continuer
      </Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
        {paymentMethods.map((method) => (
          <Box key={method.id}>
            <Card
              sx={{
                cursor: method.enabled ? 'pointer' : 'not-allowed',
                opacity: method.enabled ? 1 : 0.5,
                border: '2px solid transparent',
                transition: 'all 0.2s ease-in-out',
                '&:hover': method.enabled
                  ? {
                      borderColor: 'white',
                      transform: 'translateY(-2px)',
                      boxShadow: 3,
                    }
                  : {},
              }}
              onClick={() => handleMethodClick(method)}
            >
              <CardContent sx={{ textAlign: 'center', py: 3 }}>
                <Avatar
                  sx={{
                    bgcolor: method.enabled ? 'white' : 'grey.400',
                    width: 60,
                    height: 60,
                    mx: 'auto',
                    mb: 2,
                  }}
                >
                  {getIcon(method.icon)}
                </Avatar>
                <Typography variant="h6" gutterBottom>
                  {method.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {method.enabled ? 'Disponible' : 'Bientôt disponible'}
                </Typography>
                {method.enabled && (
                  <CheckCircle
                    color="success"
                    sx={{ mt: 1, fontSize: 20 }}
                  />
                )}
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
        Toutes les transactions sont sécurisées avec une encryption 256-bit SSL
      </Typography>
    </Box>
  );
};

export default PaymentMethodSelector; 